export function isLanguage(expected: string, actual: string) {
	return actual.startsWith(expected)
}
